module.exports = __webpack_public_path__ + "img/GamePerformance.d49410af.jpg";